import { jsx as r, Fragment as h, jsxs as d } from "react/jsx-runtime";
import { useCallback as f } from "react";
import { MenuItem as c } from "../menu-item/index.js";
import n from "./styles.module.less.js";
import { DropdownMenuItemMobile as y } from "../dropdown-menu-item/index.js";
import k from "./world.svg.js";
import v from "./user.svg.js";
import I from "./lawyer-sign-up.svg.js";
import { getRoute as m, RouteType as g } from "../../../../utils/get-route.js";
const C = (p) => {
  const { getTranslation: e, language: t, isScrolledHeader: o, isActive: i, useWill: l, environment: a } = p, w = a === "dev" || a === "development" ? "https://portal.development.lawconnect.com" : a === "staging" ? "https://portal.staging.lawconnect.com" : "https://portal.lawconnect.com", u = f(() => {
    window.location.href = `/${t}/for-lawyers/legal-network`;
  }, [t]);
  return l ? /* @__PURE__ */ r(
    c,
    {
      label: "Make a will",
      path: m(g.WILL_INFO),
      hasShrunk: o,
      isActive: i
    }
  ) : /* @__PURE__ */ r(
    c,
    {
      label: e("register.for-lawyers"),
      chevronStyle: "rotate",
      hasShrunk: o,
      isActive: i,
      onClick: u,
      classNames: {
        wrapper: n.buttonWrapper,
        childContainer: `${n.hoverMenu} ${o ? n.scrolledHeader : ""}`
      },
      children: /* @__PURE__ */ r(h, { children: [
        {
          path: `/${t}/for-lawyers/legal-network`,
          title: e("about.menu.legal-network"),
          icon: /* @__PURE__ */ r(k, { className: n.menuIcon })
        },
        {
          path: `/${t}/for-lawyers/sign-up`,
          title: e("pages.sign-up"),
          icon: /* @__PURE__ */ r(I, { className: n.menuIcon })
        },
        {
          path: w,
          title: e("lawyer.lawyer-portal"),
          icon: /* @__PURE__ */ r(v, { className: n.menuIcon })
        }
      ].map((s) => /* @__PURE__ */ d("a", { href: s.path, className: n.menuItem, children: [
        /* @__PURE__ */ r("span", { className: `${n.menuItemText}`, children: s.title }),
        s.icon
      ] }, s.title)) })
    }
  );
}, T = (p) => {
  const { getTranslation: e, language: t, classNames: o, useWill: i, environment: l } = p;
  if (i)
    return /* @__PURE__ */ r("a", { href: m(g.WILL_INFO), className: o == null ? void 0 : o.mainMenuLink, children: "Make a will" });
  const a = l === "dev" || l === "development" ? "https://portal.development.lawconnect.com" : l === "staging" ? "https://portal.staging.lawconnect.com" : "https://portal.lawconnect.com";
  return /* @__PURE__ */ r(
    y,
    {
      language: t,
      titleLabel: e("register.for-lawyers"),
      link: `/${t}/for-lawyers/legal-network`,
      items: [
        {
          title: e("about.menu.legal-network"),
          description: e("register.legal-network-description"),
          path: `/${t}/for-lawyers/legal-network`
        },
        {
          title: e("pages.sign-up"),
          description: e("register.register-interest-description"),
          path: `/${t}/for-lawyers/sign-up`
        },
        {
          title: e("lawyer.lawyer-portal"),
          description: e("lawyer.lawyer-portal-description"),
          path: a
        }
      ],
      classNames: o
    }
  );
};
export {
  C as ForLawyersMenuButtonDesktop,
  T as ForLawyersMenuButtonMobile
};
